import { i18n } from '@/plugins/i18n'
import { customerStatusVariant, customerStatusStr } from "@/constants/customerStatus";


export default [
    {
        field: 'id',
        title: i18n.t('online-factor.hash_id'),
        sortable: true,
        width: 50,
        textAlign: 'center',
    },
    {
        field: 'name',
        title: i18n.t('online-factor.name'),
        sortable: true,
        width: 50,
        textAlign: 'center',
    },
    {
        field: 'created_at',
        title: i18n.t('online-factor.created_at'),
        sortable: true,
        width: 50,
        textAlign: 'center',
    },
]
